// Coaching one-liner derived deterministically from the injury-risk
// prediction. Extracted from DecisionEnginePage.js during Phase 1
// consolidation — no logic or visual changes.
import React from 'react';

export const ACTION_HINT_DOT = {
  high: 'bg-red-500',
  moderate: 'bg-amber-500',
  low: 'bg-emerald-500',
};

export const ActionHintStrip = ({ hint, riskLevel }) => {
  if (!hint || !hint.recommendation) return null;
  // Medical-caution override comes from text, not level — keep colour aligned
  // with the risk_level tone for visual consistency with the badge.
  const tone = ACTION_HINT_DOT[riskLevel] || ACTION_HINT_DOT.low;
  return (
    <div
      className="flex items-center gap-2 text-[12px] text-gray-700 dark:text-gray-300 px-1"
      data-testid="action-hint-strip"
      data-risk-level={riskLevel || 'low'}
      aria-label="Action hint"
    >
      <span className={`inline-block h-2 w-2 rounded-full shrink-0 ${tone}`} aria-hidden="true" />
      <span className="truncate" data-testid="action-hint-text">{hint.recommendation}</span>
    </div>
  );
};
